import FullObjectSelection from '../FullObjectSelection/FullObjectSelection';
import MessagesUnassigned from './MessagesUnassigned';
import MessagesAssigned from './MessagesAssigned';

function MessageSelection({
  filters = null,
  selected = [],
  columns = [],
  emptyTitle = 'Add Messages to Your Message Block',
  // eslint-disable-next-line max-len
  emptyDescription = 'Add messages like you would add songs to a playlist. Schedule this set of messages to play for any length of time at any of the locations you’ve chosen!',
  allowCustomOrder = false,
  allowChanges = false,
  customToolbar = null,
  assigning = false,
  onChange = () => {},
}) {
  if (assigning) {
    return (
      <FullObjectSelection className="MessageSelection">
        <MessagesUnassigned
          columns={columns}
          emptyTitle={emptyTitle}
          emptyDescription={emptyDescription}
          selected={selected}
          customToolbar={customToolbar}
          filters={filters}
          onChange={onChange}
        />
      </FullObjectSelection>
    );
  }

  return (
    <FullObjectSelection className="MessageSelection">
      <MessagesAssigned
        columns={columns}
        emptyTitle={emptyTitle}
        emptyDescription={emptyDescription}
        selected={selected}
        allowCustomOrder={allowCustomOrder}
        allowChanges={allowChanges}
        customToolbar={customToolbar}
        onChange={onChange}
      />
    </FullObjectSelection>
  );
}

export default MessageSelection;
